import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { AdminService } from '../../../../services/core.admin.service';
import { UiService } from '../../../../services/core.ui.service';
import { GfTitleService } from '../../../../services/core.title.service';
import { doPromiseAll } from '../../../../config/core.promise-utils';

import * as _ from 'lodash-es';

@Component({
    selector: 'site-admin-homepage-options',
    template: require('./site.admin.homepage.options.component.html')
})
export class SiteAdminHomepageOptionsComponent implements OnInit {

    @Input() setting: any = null;
    
    protected onOff = { 'Standard': 'N', 'Custom': 'Y' };
    protected apidocFlags = {
        'Everyone': 0,
        'Users': 1,
        'Never': 2
    };
    protected saving = false;
    private originalSettings: any = null;

    constructor(
        private $window: Window,
        private stateService: StateService,
        private adminService: AdminService,
        private uiService: UiService,
        private titleService: GfTitleService,
    ) { }
    
    ngOnInit() {
        this.originalSettings = _.clone(this.setting);
        this.titleService.setTitle('Site Admin', 'Homepage');
    };

    saveChanges = () => {
        var allSaves = _.reduce(
            this.setting,
            (carry, value, key) => {
                if (value != _.get(this.originalSettings, key, '')) {
                    carry[key] = this.updateSetting(key, value);
                }
                return carry;
            }, {}
        );

        if (_.keys(allSaves).length > 0) {
            this.saving = true;
            doPromiseAll(allSaves).then(() => {
                this.$window['useCustomSiteSplash'] = this.setting.useCustomSiteSplash;
                this.stateService.reload('home').then(() => {
                    this.uiService.message.showSuccess("Changes were saved successfully", "Site Admin - Homepage");
                    this.originalSettings = this.setting;
                });
            }).finally(() => {
                this.saving = false;
            });
        } else {
            this.uiService.message.showWarning("No changes to save", "Site Admin - Homepage");
        }
    };

    setConfigValue(path, value) {
        console.log('setConfigValue', path, value);
        if (value == undefined || value == _.get(this, path)) return false;
        _.set(this, path, value);
    };

    updateSetting(settingName, newValue) {
        console.log('updateSetting', settingName, newValue);
        var params = {
            section: 'config',
            refId: 0,
            settingName: 'system.' + settingName,
            settingValue: null
        };

        if (newValue == '') {
            return this.adminService.deleteConfig('config', 0, 'system.' + settingName);
        } else {
            params.settingValue = newValue;
            return this.adminService.postConfig(params);
        }
    }
};